export const BADGE_VARIANTS = {
  outline: 'outline',
  white: 'white',
  gray: 'gray',
  ink: 'ink',
  success: 'success',
  caution: 'caution',
  warning: 'warning',
  yellow: 'yellow',
  blue: 'blue',
  pink: 'pink',
};
